import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "footer__address" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "footer__heading" }, "Адрес:"),
  /*#__PURE__*/_createElementVNode("p", null, "Малаховка, Касимовское шоссе 3а")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "footer__hours" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "footer__heading" }, "Часы работы:"),
  /*#__PURE__*/_createElementVNode("p", null, "C 10:00 до 19:00")
], -1)
const _hoisted_6 = { class: "footer__phones" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "footer__heading" }, "Телефоны:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "footer__social" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "footer__heading" }, "Наш инстраграм:"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "footer__social-link",
      href: "https://vk.com/away.php?to=https%3A%2F%2Finstagram.com%2Favangard_auto__%3Futm_medium%3Dcopy_link&cc_key=",
      target: "_blank"
    }, "Avangard Service")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_APhones = _resolveComponent("APhones")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_APhones)
        ]),
        _hoisted_8
      ])
    ])
  ]))
}